<template>
    <!--Client Waiting List Page-->
    <div class="client-waiting-list">
        <!--Heading-->
        <h3>{{ $ml.get("waitingListClient.title") }}</h3>
        <!--Client Waiting List Main Wrapper-->
        <div class="client-wlist section-wrap" v-if="currentSection === 'client-wlist' && !loadedStylists">
            <!--Subtitle-->
            <h5>{{ $ml.get("waitingList.title") }}</h5>
            <!--Main Content-->
            <div v-for="stylist in stylistsWithWaitlist" :key="stylist.index" class="wlist-wrapper">
                <div class="wlist-stylist section-wrap">
                    <!--Stylists with waitlist active-->
                    <div class="text-wrap">
                        <p v-if="!stylist.waiting_list_settings.completed">
                            <span>{{ stylist.first_name }} {{ stylist.last_name }}</span> has an open waitlist! Click
                            'Continue' to secure your spot.
                        </p>
                        <div class="wlist-completed" v-if="stylist.waiting_list_settings.completed">
                            <p>You’re on <span>{{ stylist.first_name }} {{ stylist.last_name }}</span>'s waitlist for
                                '<span>{{ stylist.waiting_list_settings.service_names[0] }}</span>'
                                <span>({{
                                    getFormattedDate(stylist.waiting_list_settings.from_date, "MMM D, YYYY") }}–{{
                                    getFormattedDate(stylist.waiting_list_settings.to_date, "MMM D, YYYY") }}).
                                </span>
                            </p>
                            <p>You will be notified by <span>{{
                                formatNotificationMethod(stylist.waiting_list_settings.notification_method)
                            }}</span> as soon as a spot becomes available.</p>
                        </div>
                    </div>
                    <div class="continue-btn-wrap"
                        :class="stylist.waiting_list_settings.completed === 1 ? 'change-layout' : ''">
                        <button class="continue-btn primary-btn extra-small mobile"
                            @click="currentSectionMethod('client-step1', stylist)">
                            {{ !stylist.waiting_list_settings.completed ? $ml.get("general.continue") : 'Edit' }}
                        </button>
                        <button v-if="stylist.waiting_list_settings.completed" @click="setStylistId(stylist.id)"
                            type="button" data-toggle="modal" data-target="#cancelWaitlistClient"
                            class="cancel-btn primary-btn extra-small mobile">
                            {{ $ml.get("general.cancel") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!--Main Loader-->
        <main-loader class="section-wrap" v-if="loadedStylists"></main-loader>
        <!--First Step-->
        <client-step-one v-if="currentSection === 'client-step1'" @change-section="changeSection"
            :client="currentStylist">
        </client-step-one>
        <!--Second Step-->
        <client-step-two v-if="currentSection === 'client-step2'" @change-section="changeSection"></client-step-two>
        <!--Third Step-->
        <client-step-three v-if="currentSection === 'client-step3'" @change-section="changeSection"></client-step-three>
        <!--Fourth Step-->
        <client-step-four v-if="currentSection === 'client-step4'" @change-section="changeSection"></client-step-four>
        <!--Final Step-->
        <client-final-step v-if="currentSection === 'client-final-step'" @change-section="changeSection">
        </client-final-step>
        <!--Cancel Waitlist Modal-->
        <waiting-list-modal title="Cancel Waitlist" p1="Are you sure you want to leave Waitlist ?"
            id="cancelWaitlistClient" buttonText="Yes" buttonText2="No" :cancelWaitlistClient="true"
            @cancel-waitlist-client="resetClientWaitlistSettings">
        </waiting-list-modal>
    </div>
</template>

<script>
import ClientStepOne from './parts/client_step_one.vue';
import ClientStepTwo from './parts/client_step_two.vue';
import ClientStepThree from './parts/client_step_three.vue';
import ClientStepFour from './parts/client_step_four.vue';
import ClientFinalStep from './parts/client_final_step.vue';
import store from "../../../../services/vuex";
import api from "../../../../services/api_endpoints";
import MainLoader from '../../general-components/main_loader.vue';
import moment from "moment";
import WaitingListModal from '../parts/waiting_list_modal.vue';
import messages from '../../../../services/messages';

export default {
    data() {
        return {

            currentSection: '',
            currentStylist: {},
            stylists: [],
            stylistsWithWaitlist: [],
            loadedStylists: false,
            stylistId: null,
        };
    },
    computed: {
        currentWaitingListStylist: {
            get: function () {
                return store.state.currentWaitingListStylist;
            },
            set: function (value) {
                store.commit("setCurrentWaitingListStylist", value);
            },
        },
    },
    mounted() {
        this.currentSection = 'client-wlist';
        this.getStylists();

    },
    components: {
        ClientStepOne,
        ClientStepTwo,
        ClientStepThree,
        ClientStepFour,
        ClientFinalStep,
        MainLoader,
        WaitingListModal,
    },
    methods: {
        currentSectionMethod(section, stylist) {
            this.currentSection = section;
            this.currentWaitingListStylist = stylist;
            this.getClientWaitlistSettings(stylist.id);
        },
        changeSection(section) {
            this.currentSection = section;

            if (this.currentSection == 'client-wlist') {
                this.getStylists();
            }
        },
        getStylists() {
            this.loadedStylists = true;
            this.stylistsWithWaitlist = [];

            this.$http.get(api.actions.get_stylists + "?working=1&exclude_blocked=1").then(
                function (response) {
                    if (typeof response.data.stylists != "undefined") {
                        this.stylists = response.data.stylists;

                        this.stylists.forEach((stylist) => {
                            if (stylist.waiting_list_active && stylist.waiting_list_enrollment_finished) {
                                this.stylistsWithWaitlist.push(stylist);
                            }
                        })

                        this.loadedStylists = false;
                    }
                }.bind(this)
            );
        },
        getClientWaitlistSettings(stylistId) {
            this.$http.get(api.actions.get_client_waitlist_settings + "/" + stylistId).then(
                function (response) {
                    if (response.data.error == true) {
                        return;
                    }
                }.bind(this)
            );
        },
        setStylistId(id) {
            this.stylistId = id;
        },

        resetClientWaitlistSettings() {
            let data = {
                stylist_id: this.stylistId,
            };

            this.$http.post(api.actions.reset_client_waitlist_settings, data).then((response) => {

                if (response.data.error == true) {
                    return;
                }

                this.getStylists();
                messages.successMessage(messages.GLOBAL_MESSAGES.LEFT_WAITING_LIST);
            });
            return;
        },
        getFormattedDate(date, format) {
            return moment(date).format(format);
        },

        formatSendTime(time) {
            let sendTime = '';

            if (time === '12_hours') {
                sendTime = 'in 12 hours';
            }

            if (time === 'immediately') {
                sendTime = 'immediately';
            }

            if (time === '24_hours') {
                sendTime = 'in 24 hours';
            }

            if (time === '1_hour') {
                sendTime = 'in 1 hour';
            }

            return sendTime;
        },
        formatNotificationMethod(notification) {
            let notificationMethod = '';

            if (notification === 'sms') {
                notificationMethod = 'Text Message(SMS)';
            }

            if (notification === 'push') {
                notificationMethod = 'App Notification';
            }

            if (notification === 'email') {
                notificationMethod = 'Email Message';
            }

            return notificationMethod;
        }
    },
};
</script>
